import { styled } from '@/stitches.config';

import { Box, TableCell, TableRow } from '../../../atoms';

export const StyledTableHeadRow = styled(TableRow, {
  color: '$darkBlue300',
  fontSize: '$4',
  lineHeight: '$6',
  fontWeight: '$bold',
  backgroundColor: '$white',
  variants: {
    disabled: {
      true: {
        color: '$coolGray100',
        pointerEvents: 'none',
      },
    },
  },
});

export const StyledTableHeadCell = styled(TableCell, {
  cursor: 'auto',
});

export const StyledSortableTableHeadCell = styled(TableCell, {
  cursor: 'pointer',
  variants: {
    disabled: {
      true: {
        cursor: 'not-allowed',
      },
    },
  },
});

export const StyledTableHeadContent = styled(Box, {
  display: 'inline-flex',
  verticalAlign: 'center',
});

const StyledCaret = styled(Box, {
  display: 'inline-block',
  margin: '$1 $1',
  verticalAlign: 'center',
  width: '0',
  height: '0',
});

export const StyledGreyCaretDown = styled(StyledCaret, {
  borderLeft: '$borderWidths$5 solid transparent',
  borderRight: '$borderWidths$5 solid transparent',
  borderTop: '$borderWidths$5 solid $colors$darkBlue700',
});

export const StyledCaretUp = styled(StyledCaret, {
  borderLeft: '$borderWidths$5 solid transparent',
  borderRight: '$borderWidths$5 solid transparent',
  borderBottom: '$borderWidths$5 solid $colors$black',
});

export const StyledCaretDown = styled(StyledCaret, {
  borderLeft: '$borderWidths$5 solid transparent',
  borderRight: '$borderWidths$5 solid transparent',
  borderTop: '$borderWidths$5 solid $colors$black',
});
